const docTypesToOmitCounts = [
  'Evidence briefs for policy',
  'Economic evaluations and costing studies',
  'Health system descriptions',
  'Health reform descriptions',
];

const alwaysUseDefault = [
  'Evidence syntheses in progress',
  'Evidence syntheses being planned',
];

const shouldShowCount = (docType) => !docTypesToOmitCounts.includes(docType);

const shouldAlwaysShowDefault = (docType) => alwaysUseDefault.includes(docType);

const getCountries = (t, result) => {
  let countries = result.countries?.trim();
  const type = result.type;

  const NOT_TYPICALLY_PRESENTED = t(
    'search_page.result_item.not_typically_presented'
  );
  const NOT_YET_AVAILABLE = t('search_page.result_item.not_yet_available');

  const defaultPhrases = {
    'Evidence briefs for policy': NOT_TYPICALLY_PRESENTED,
    'Overviews of evidence syntheses': NOT_YET_AVAILABLE,
    'Evidence syntheses of effects': NOT_YET_AVAILABLE,
    'Evidence syntheses addressing other questions': NOT_YET_AVAILABLE,
    'Evidence syntheses in progress': NOT_TYPICALLY_PRESENTED,
    'Evidence syntheses being planned': NOT_TYPICALLY_PRESENTED,
    'Economic evaluations and costing studies': NOT_TYPICALLY_PRESENTED,
    'Health reform descriptions': NOT_TYPICALLY_PRESENTED,
    'Health system descriptions': NOT_TYPICALLY_PRESENTED,
  };

  // Labels to strip out entirely before parsing
  const labelsToStrip = [
    'No studies met the inclusion criteria set for the review',
    'Not reported',
    'Not typically presented in a systematic review being planned',
    'Not typically presented in a systematic review in progress',
    'Not typically presented in an overview',
    'Not yet available',
  ];

  console.log('[DEBUG] Type:', type);
  console.log('[DEBUG] Countries (raw):', countries);

  if (alwaysUseDefault.includes(type)) {
    console.log('[DEBUG] Using always-default due to document type.');
    return defaultPhrases[type] || '';
  }

  // Strip (0) counts and trim
  countries = countries?.replace(/\(0\)/g, '').trim();

  // Early exit if string is empty or only contains semicolons/spaces
  const isEmpty = !countries || countries.replaceAll(';', '').trim() === '';
  if (isEmpty) {
    console.log('[DEBUG] Countries string is empty after cleanup.');
    return defaultPhrases[type] || '';
  }

  const countryEntries = countries
    .split(';')
    .map((entry) => entry.trim())
    .filter((entry) => {
      const shouldRemove = labelsToStrip.some((phrase) =>
        entry.startsWith(phrase)
      );
      if (shouldRemove) {
        console.log('[DEBUG] Skipping label phrase:', entry);
      }
      return !shouldRemove && entry.length > 0;
    })
    .map((entry) => {
      const matchesSpecialPhrase = labelsToStrip.some((phrase) =>
        entry.startsWith(phrase)
      );
      if (docTypesToOmitCounts.includes(type) || matchesSpecialPhrase) {
        console.log('[DEBUG] Stripping counts from entry:', entry);
        return entry.replace(/\s*\(\d+\)/g, '').trim();
      }
      return entry.trim();
    });

  if (countryEntries.length === 0) {
    console.log('[DEBUG] No usable country entries remain after filtering.');
    return defaultPhrases[type] || '';
  }

  const resultPhrase = countryEntries.join('; ');
  console.log('[DEBUG] Final country list:', resultPhrase);

  return resultPhrase;
};

module.exports = {
  getCountries,
  shouldShowCount,
  shouldAlwaysShowDefault,
};
